/*
 * Created by Ali Simsek on 5/19/20, 3:43 PM
 * Copyright (c) 2020 Carla Car Rental, Inc. All rights reserved.
 * Last modified 5/19/20, 10:40 AM
 */

import debug from 'debug'
import util from '../util'
import API from './API'

const log = debug('carla:worker')

let oneSignalIntiialized = false

export const init = () => {
  if (util.isServer() || oneSignalIntiialized) return
  const OneSignal = window.OneSignal || []
  oneSignalIntiialized = true

  OneSignal.push(() => {
    OneSignal.init({
      allowLocalhostAsSecureOrigin: true,
      appId: '1496ca1b-fc56-4c06-9df5-b5df80ef4207',
      autoResubscribe: true
      // notifyButton: {
      //   enable: true,
      //   size: 'large',
      //   prenotify: true,
      //   showCredit: false,
      //   displayPredicate: () => {
      //     if (showNotifyButton === false) {
      //       return false
      //     }
      //     return OneSignal.isPushNotificationsEnabled()
      //       .then(function(isPushEnabled) {
      //         /* The user is subscribed, so we want to return "false" to hide the Subscription Bell */
      //         return !isPushEnabled;
      //       })
      //   },
      //   text: {
      //     'tip.state.unsubscribed': 'Alert me when price goes down!',
      //     'tip.state.subscribed': "You will be alerted when price goes down",
      //     'tip.state.blocked': "You've blocked notifications",
      //     'message.prenotify': 'Alert me when price goes down!',
      //     'message.action.subscribed': "Thanks for subscribing!",
      //     'message.action.resubscribed': "You're subscribed to notifications",
      //     'message.action.unsubscribed': "You won't receive notifications again",
      //     'dialog.main.title': 'Manage Site Notifications',
      //     'dialog.main.button.subscribe': 'SUBSCRIBE',
      //     'dialog.main.button.unsubscribe': 'UNSUBSCRIBE',
      //     'dialog.blocked.title': 'Unblock Notifications',
      //     'dialog.blocked.message': "Follow these instructions to allow notifications:"
      //   },
      //   colors: {
      //     'circle.background': colors.deepOrange[7],
      //     'circle.foreground': colors.newColorPrimary,
      //   }
      // }
    })

    OneSignal.getUserId().then((userId) => console.log(`signal-"${userId}"`))
  })

  OneSignal.push(() => {
    OneSignal.on('notificationPermissionChange', ({ to }) => {
      if (to === 'granted') {
        OneSignal.getUserId()
          .then((id) => {
            if (id) {
              log(`updating onesignal device token: ${id}`)
              API.updateDevice(id)
            }
          })
          .catch((err) => {
            console.error('error getting onesignal id', err)
          })
      }
    })
  })
}

export const askPermission = () => {
  if (util.isServer() || !window.OneSignal) return

  const { OneSignal } = window
  OneSignal.push(() => {
    OneSignal.showNativePrompt()
  })
}

export default { init, askPermission }
